import React from 'react';
export function ProductBreakdown() {
  const products = [{
    title: 'EBOOK 1 — GUÍA COMPLETA DE CRIANZA',
    value: '$21.000',
    color: 'bg-brand-sage',
    image: 'https://cdn.magicpatterns.com/uploads/a1ucxzbmvAv88ReZGGb89a/MOCKUP_EBOOK_PRIMEROS_PASOS.png'
  }, {
    title: 'EBOOK 2 — 100 ACTIVIDADES Y JUEGOS',
    value: '$21.000',
    color: 'bg-brand-light',
    image: 'https://cdn.magicpatterns.com/uploads/px3Xq7FZWG1G3tE7tj2UoM/MOCKUP_EBOOK_100_ACTIVIDADES.png'
  }];
  return <section className="bg-white py-24 px-6" data-id="element-211">
      <div className="max-w-5xl mx-auto" data-id="element-212">
        <div className="text-center mb-16" data-id="element-213">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif text-brand-black mb-4" data-id="element-214">
            Qué te llevás hoy
          </h2>
          <p className="text-xl text-brand-charcoal/70" data-id="element-215">
            Todo lo que necesitás para los primeros 3 años
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-216">
          {products.map((product, index) => <div key={index} className="bg-brand-cream rounded-3xl p-8 border border-brand-sage/10 relative overflow-hidden group hover:shadow-xl transition-all duration-300 flex flex-col items-center text-center" data-id="element-217">
              {/* Decorative background */}
              <div className={`absolute -right-12 -top-12 w-40 h-40 rounded-full opacity-10 ${product.color}`} data-id="element-218"></div>

              <div className="w-48 h-64 mb-8 relative group-hover:-translate-y-2 transition-transform duration-300" data-id="element-219">
                <img src={product.image} alt={product.title} className="w-full h-full object-contain drop-shadow-xl" data-id="element-220" />
              </div>

              <div className="flex flex-col h-full w-full" data-id="element-221">
                <h3 className="text-2xl font-bold text-brand-black mb-6" data-id="element-222">
                  {product.title}
                </h3>

                <div className="mt-auto pt-6 flex items-center justify-between border-t border-brand-sage/20 w-full" data-id="element-223">
                  <span className="text-brand-red line-through font-medium text-lg" data-id="element-224">
                    {product.value}
                  </span>
                  <span className="bg-brand-sage text-white text-sm font-bold px-4 py-1.5 rounded-full" data-id="element-225">
                    HOY INCLUIDO
                  </span>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}